<template>
  <div class="workspace">
    <p style="border-bottom: 1px #eee solid;padding-bottom: 20px;">
      {{$t('default.title')}}
    </p>
    <div class="info">
      <el-button @click="$router.push('/')" class="login-button" style="float: right; position: relative;" type="primary">
        {{ $t('default.logout') }}
      </el-button>
      <div class="data-item">
        <label for="" class="item-label">{{$t('default.institution_id')}}</label>
        <span class="item-value">{{ organizationId }}</span>
      </div>
      <div class="data-item">
        <label for="" class="item-label">{{$t('default.study_id')}}</label>
        <span class="item-value">{{studyId}}</span>
      </div>
      <div class="data-item">
        <label for="" class="item-label">{{$t('default.name')}}</label>
        <span class="item-value">{{name}}</span>
      </div>
      <div class="data-item">
        <label for="" class="item-label">{{$t('default.ethnicity')}}</label>
        <span class="item-value"> {{ ethnicitysMap[ethnicity] }}</span>
      </div>
      <div class="data-item">
        <label for="" class="item-label">{{$t('default.birthday')}}</label>
        <span class="item-value">{{ birthday }}</span>
      </div>
      <div class="data-item">
        <label for="" class="item-label">{{$t('default.sex')}}</label>
        <span class="item-value">{{ sex }}</span>
      </div>
    </div>
    <el-collapse v-model="activeNames">
      <el-collapse-item :title="$t('default.treatment_history')" name="2">
        <table class="data-table" border="">
          <thead>
            <tr>
              <th></th>
              <th>{{$t('default.OD')}}</th>
              <th>{{$t('default.OS')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{$t('default.treatment_history')}}</td>
              <td>
                <span v-for="me in historyMethods" :key="me">
                  <span v-if=" history && history.data[`od_tofct_${me}`]">
                    {{ methodsMap[me] }}
                  </span>
                  <span v-if=" history && history.data[`od_tofct_${me}`] && me === 'others_text'">
                    {{ history.data[`od_tofct_${me}`] && $t('default.other') }}{{ history.data[`od_tofct_${me}`] }}
                  </span>
                </span>
              </td>
              <td>
                <span v-for="me in historyMethods" :key="me">
                  <span v-if=" history && history.data[`os_tofct_${me}`]">
                    {{ methodsMap[me] }}
                  </span>
                  <span v-if=" history && history.data[`os_tofct_${me}`] && me === 'others_text'">
                    {{ history.data[`os_tofct_${me}`] && $t('default.other') }}{{ history.data[`os_tofct_${me}`] }}
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{$t('default.duration_of_treatment')}}</td>
              <td> {{  history && history.data.od_treatment_year }}
                {{  history && history.data.od_treatment_year && $t('default.year')}}
                {{  history && history.data.od_treatment_month }}
                {{  history && history.data.od_treatment_month && $t('default.month') }}
                </td>
              <td> {{  history && history.data.os_treatment_year }}
                {{  history && history.data.os_treatment_year && $t('default.year')}}
                {{  history && history.data.os_treatment_month }}
                {{  history && history.data.os_treatment_month && $t('default.month')}}
                </td>
            </tr>
            <tr>
              <td>{{$t('default.refractive_error_progression')}}</td>
              <td>{{ history && history.data.od_SER_progression }} {{ history && history.data.od_SER_progression && $t('default.D_per_year') }}</td>
              <td>{{ history && history.data.os_SER_progression }} {{ history && history.data.os_SER_progression && $t('default.D_per_year') }}</td>
            </tr>
            <tr>
              <td>{{$t('default.axial_elongation')}}</td>
              <td>{{ history && history.data.od_axial_elongation }} {{ history && history.data.od_axial_elongation && $t('default.mm_per_year') }}</td>
              <td>{{ history && history.data.os_axial_elongation }} {{ history && history.data.os_axial_elongation && $t('default.mm_per_year') }}</td>
            </tr>
          </tbody>
        </table>
        <div class="data-item">
          <label for="" class="item-label">{{$t('default.initial_selection_results')}}：</label>
          <span class="item-value">{{ history && history.data.initital_selection_results }}</span>
        </div>
      </el-collapse-item>
      <el-collapse-item :title="$t('default.first_examination_results')" name="3">
        <div class="data-item">
          <label for="" class="item-label">{{$t('default.date_of_visit')}}：</label>
          <span class="item-value">{{ firstRecord && firstRecord.data.date_of_visit }}</span>
        </div>
        <table class="data-table" border="">
          <thead>
            <tr>
              <th></th>
              <th>{{$t('default.OD')}}</th>
              <th>{{$t('default.OS')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{$t('default.axial_length')}}</td>
              <td>{{ firstRecord && firstRecord.data.od_axial_length }} {{ firstRecord && firstRecord.data.od_axial_length && $t('default.mm') }}</td>
              <td>{{ firstRecord && firstRecord.data.os_axial_length }} {{ firstRecord && firstRecord.data.os_axial_length && $t('default.mm') }}</td>
            </tr>
            <tr>
              <td>{{$t('default.subjective_refraction')}}</td>
              <td> {{firstRecord && firstRecord.data.od_subjective_refraction_1}}{{firstRecord && firstRecord.data.od_subjective_refraction_1 && $t('default.spherical_diopter')}}
                / {{firstRecord && firstRecord.data.od_subjective_refraction_2}}{{firstRecord && firstRecord.data.od_subjective_refraction_2 && $t('default.cylindrical_diopter')}}
                {{firstRecord && firstRecord.data.od_subjective_refraction_3}}{{firstRecord && firstRecord.data.od_subjective_refraction_3 && $t('default.axis_degree') }}</td>
              <td> {{firstRecord && firstRecord.data.os_subjective_refraction_1}}{{firstRecord && firstRecord.data.os_subjective_refraction_1 && $t('default.spherical_diopter')}}
                / {{firstRecord && firstRecord.data.os_subjective_refraction_2}}{{firstRecord && firstRecord.data.os_subjective_refraction_2 && $t('default.cylindrical_diopter')}}
                {{firstRecord && firstRecord.data.os_subjective_refraction_3}}{{firstRecord && firstRecord.data.os_subjective_refraction_3 && $t('default.axis_degree') }}</td>
            </tr>
            <tr>
              <td>{{$t('default.cycloplegic_refraction')}}</td>
              <td> {{firstRecord && firstRecord.data.od_cycloplegic_refraction_1}}{{firstRecord && firstRecord.data.od_cycloplegic_refraction_1 && $t('default.spherical_diopter')}}
                / {{firstRecord && firstRecord.data.od_cycloplegic_refraction_2}}{{firstRecord && firstRecord.data.od_cycloplegic_refraction_2 && $t('default.cylindrical_diopter')}}
                {{firstRecord && firstRecord.data.od_cycloplegic_refraction_3}} {{firstRecord && firstRecord.data.od_cycloplegic_refraction_3 && $t('default.axis_degree') }}</td>
              <td> {{firstRecord && firstRecord.data.os_cycloplegic_refraction_1}}{{firstRecord && firstRecord.data.os_cycloplegic_refraction_1 && $t('default.spherical_diopter')}}
                / {{firstRecord && firstRecord.data.os_cycloplegic_refraction_2}}{{firstRecord && firstRecord.data.os_cycloplegic_refraction_2 && $t('default.cylindrical_diopter')}}
                {{firstRecord && firstRecord.data.os_cycloplegic_refraction_3}}{{firstRecord && firstRecord.data.os_cycloplegic_refraction_3 && $t('default.axis_degree') }}</td>

            </tr>
            <tr>
              <td>{{$t('default.best_corrected_visual_acuity')}}</td>
              <td>{{ firstRecord && firstRecord.data.od_bcva }}</td>
              <td>{{ firstRecord && firstRecord.data.os_bcva }}</td>
            </tr>
            <tr>
              <td>{{$t('default.visual_acuity_notes')}}</td>
              <td>{{ firstRecord && firstRecord.data.od_va_mark }}</td>
              <td>{{ firstRecord && firstRecord.data.os_va_mark }}</td>
            </tr>
            <tr>
              <td>{{$t('default.new_treatment_plan')}}</td>
              <td>{{ firstRecord && treatmentMap[firstRecord.data.od_type_of_intervention] }} {{ firstRecord && firstRecord.data.od_intervention_other && $t('default.other') }}{{ firstRecord && firstRecord.data.od_intervention_other }}</td>
              <td>{{ firstRecord && treatmentMap[firstRecord.data.os_type_of_intervention] }} {{ firstRecord && firstRecord.data.os_intervention_other && $t('default.other') }}{{ firstRecord && firstRecord.data.os_intervention_other }}</td>
            </tr>
          </tbody>
        </table>
        <div class="data-item">
          <label for="" class="item-label">{{$t('default.oct_report_conclusion')}}：</label>
          <span class="item-value">{{ firstRecord && firstRecord.data.oct_report_description }}</span>
        </div>
        <div class="data-item">
          <label for="" class="item-label">{{$t('default.date_of_rlrltherapy_commencement')}}：</label>
          <span class="item-value">{{ firstRecord && firstRecord.data.date_of_rlrltherapy_commencement }}</span>
        </div>
      </el-collapse-item>
      <el-collapse-item v-for="record in records" :title="$t(`default.follow_up_text`).replace('{n}', record.idx)" :name="`s_${record.idx}`" :key="`s_${record.idx}`">
        <div class="data-item">
          <label for="" class="item-label">{{$t('default.date_of_visit')}}：</label>
          <span class="item-value">{{ record && record.data.date_of_visit }}</span>
        </div>
        <table class="data-table" border="">
          <thead>
            <tr>
              <th></th>
              <th>{{$t('default.OD')}}</th>
              <th>{{$t('default.OS')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{$t('default.axial_length')}}</td>
              <td>{{ record && record.data.od_axial_length }} {{ record && record.data.od_axial_length && $t('default.mm') }}</td>
              <td>{{ record && record.data.os_axial_length }} {{ record && record.data.os_axial_length && $t('default.mm') }}</td>
            </tr>
            <tr>
              <td>{{$t('default.subjective_refraction')}}</td>
              <td> {{record && record.data.od_subjective_refraction_1}}{{record && record.data.od_subjective_refraction_1 && $t('default.spherical_diopter')}}
                / {{record && record.data.od_subjective_refraction_2}}{{record && record.data.od_subjective_refraction_2 && $t('default.cylindrical_diopter')}}
                {{record && record.data.od_subjective_refraction_3}}{{record && record.data.od_subjective_refraction_3 && $t('default.axis_degree') }}</td>
              <td> {{record && record.data.os_subjective_refraction_1}}{{record && record.data.os_subjective_refraction_1 && $t('default.spherical_diopter')}}
                / {{record && record.data.os_subjective_refraction_2}}{{record && record.data.os_subjective_refraction_2 && $t('default.cylindrical_diopter')}}
                {{record && record.data.os_subjective_refraction_3}}{{record && record.data.os_subjective_refraction_3 && $t('default.axis_degree') }}</td>
            </tr>
            <tr>
              <td>{{$t('default.cycloplegic_refraction')}}</td>
              <td> {{record && record.data.od_cycloplegic_refraction_1}}{{record && record.data.od_cycloplegic_refraction_1 && $t('default.spherical_diopter')}}
                / {{record && record.data.od_cycloplegic_refraction_2}}{{record && record.data.od_cycloplegic_refraction_2 && $t('default.cylindrical_diopter')}}
                {{record && record.data.od_cycloplegic_refraction_3}} {{record && record.data.od_cycloplegic_refraction_3 && $t('default.axis_degree') }}</td>
              <td> {{record && record.data.os_cycloplegic_refraction_1}}{{record && record.data.os_cycloplegic_refraction_1 && $t('default.spherical_diopter')}}
                / {{record && record.data.os_cycloplegic_refraction_2}}{{record && record.data.os_cycloplegic_refraction_2 && $t('default.cylindrical_diopter')}}
                {{record && record.data.os_cycloplegic_refraction_3}}{{record && record.data.os_cycloplegic_refraction_3 && $t('default.axis_degree') }}</td>

            </tr>
            <tr>
              <td>{{$t('default.best_corrected_visual_acuity')}}</td>
              <td>{{ record && record.data.od_bcva }}</td>
              <td>{{ record && record.data.os_bcva }}</td>
            </tr>
            <tr>
              <td>{{$t('default.visual_acuity_notes')}}</td>
              <td>{{ record && record.data.od_va_mark }}</td>
              <td>{{ record && record.data.os_va_mark }}</td>
            </tr>
            <tr>
              <td>{{$t('default.adverse_reactions')}}</td>
              <td v-if="record && record.data.od_self_reported_side_effects !== 'other'">{{ record && effectsMap[record.data.od_self_reported_side_effects] }}</td>
              <td v-else> {{ record && record.data.od_self_reported_side_effects_other}}</td>
              <td v-if="record && record.data.os_self_reported_side_effects !== 'other'">{{ record && effectsMap[record.data.os_self_reported_side_effects] }}</td>
              <td v-else> {{ record && record.data.os_self_reported_side_effects_other}}</td>
            </tr>
            <tr>
              <td>{{$t('default.continue_treatment')}}</td>
              <td>{{ record && yesOrNoMap[record.data.od_whether_to_continue] }} </td>
              <td>{{ record && yesOrNoMap[record.data.os_whether_to_continue] }} </td>
            </tr>
            <tr>
              <td>{{$t('default.reason_not_to_continue')}}</td>
              <td v-if="record && record.data.od_whether_to_continue_reason !== 'other'">{{ record && noReasonMap[record.data.od_whether_to_continue_reason] }}</td>
              <td v-else> {{ record && record.data.od_whether_to_continue_other}}</td>
              <td v-if="record && record.data.os_whether_to_continue_reason !== 'other'">{{ record && noReasonMap[record.data.os_whether_to_continue_reason] }}</td>
              <td v-else> {{ record && record.data.os_whether_to_continue_other}}</td>
            </tr>
            <tr>
              <td>{{$t('default.new_treatment_plan')}}</td>
              <td v-if="record && record.data.od_new_ongoing_treatment !== 'other'">{{ record && treatmentMap[record.data.od_new_ongoing_treatment] }}</td>
              <td v-else> {{ record && record.data.od_new_ongoing_treatment_other}}</td>
              <td v-if="record && record.data.os_new_ongoing_treatment !== 'other'">{{ record && treatmentMap[record.data.os_new_ongoing_treatment] }}</td>
              <td v-else> {{ record && record.data.os_new_ongoing_treatment_other}}</td>
            </tr>
          </tbody>
        </table>
        <div class="data-item">
          <label for="" class="item-label">{{$t('default.oct_report_conclusion')}}：</label>
          <span class="item-value">{{ record && record.data.oct_report_description }}</span>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      activeNames: ['1'],
      sexMap: {
        male: this.$t('default.male'),
        female: this.$t('default.female'),
      },
      name: '',
      sex: '',
      studyId: '',
      birthday: '',
      organizationId: '',
      ethnicity: '',
      history: null,
      eyesMap: {
        od: this.$t('default.OD'),
        os: this.$t('default.OS'),
        both: this.$t('default.Both'),
      },
      methodsMap: {
        'atropine': this.$t('default.atropine'),
        'ok': this.$t('default.ok'),
        'dims': this.$t('default.dims'),
        'untreated': this.$t('default.untreated'),
        'others': this.$t('default.others'),
      },
      treatmentMap: {
        'orthokeratology_RLRL': this.$t('default.orthokeratology_RLRL'),
        'DIMS_RLRL': this.$t('default.DIMS_RLRL'),
        'DIMS_RLRL_therapy': this.$t('default.DIMS_RLRL_therapy'),
        'orthokeratology_RLRL_therapy': this.$t('default.orthokeratology_RLRL_therapy'),
        'Stop_conventional_treatments_and_switch_to_RLRL_therapy': this.$t('default.Stop_conventional_treatments_and_switch_to_RLRL_therapy'),
        'other_RLRL_therapy': this.$t('default.other_RLRL_therapy'),
        'RLRL': this.$t('default.RLRL'),
        'unsuitable': this.$t('default.unsuitable'),
        'other': this.$t('default.other'),
      },
      effectsMap: {
        'none': this.$t('default.none'),
        'worsened_visual_acuity': this.$t('default.worsened_visual_acuity'),
        'central_scotoma': this.$t('default.central_scotoma'),
        'prolonged_afterimage_5_minutes': this.$t('default.prolonged_afterimage_5_minutes'),
        'other': this.$t('default.other'),
      },
      yesOrNoMap: {
        yes: this.$t('default.yes'),
        exit: this.$t('default.exit'),
        update: this.$t('default.update'),
      },
      ethnicitysMap: {
        'asian': this.$t('default.asian'),
        'black_african': this.$t('default.black_african'),
        'caucasian_white': this.$t('default.caucasian_white'),
        'hhspanic_Latino': this.$t('default.hhspanic_Latino'),
        'middle_eastern': this.$t('default.middle_eastern'),
        'native_american': this.$t('default.native_american'),
        'pacific_islander': this.$t('default.pacific_islander'),
        'mixed_race': this.$t('default.mixed_race'),
        'other': this.$t('default.other'),
      },
      noReasonMap: {
        'choose_an_alternative_treatment_plan': this.$t('default.choose_an_alternative_treatment_plan'),
        'patient_goes_to_another_clinic': this.$t('default.patient_goes_to_another_clinic'),
        'patient_declines': this.$t('default.patient_declines'),
        'contraindications': this.$t('default.contraindications'),
        'other': this.$t('default.other'),
      },
      eyes: ['od', 'os'],
      historyMethods: ['atropine', 'ok', 'dims', 'untreated', 'others_text'],
      firstRecord: null,
      records: []
    }
  },
  mounted () {
    this.getRecords()
    const { sex, studyId, name, birthday, ethnicity } = this.$route.query
    this.sex = this.sexMap[sex]
    this.organizationId = studyId.split('-')
    this.organizationId = this.organizationId.splice(0, 3)
    this.organizationId = this.organizationId.join('-')
    this.studyId = studyId
    this.ethnicity = ethnicity
    this.name = name
    this.birthday = moment(birthday).format('YYYY-MM-DD')
  },
  methods: {
    async getRecords () {
      let result = {}
      let { projectId, subjectId } = this.$route.query
      let projectObj = {}
      const projectIdsMap = {
        en: {
          projectId: '66d315ce4d418762fc71bde3',
          history: {
            eventId: '66d33d634d418762fc71be3b',
            crfId: '66d33bfb4d418762fc71bdfa',
          },
          firstRecord: {
            eventId: '66d33d634d418762fc71be3b',
            crfId: '66d33c164d418762fc71be12',
          },
          records_1: {
            eventId: '66d33d8a4d418762fc71be42',
            crfId: '66d33c304d418762fc71be2a',
          },
          records_2: {
            eventId: '66d33daa4d418762fc71be49',
            crfId: '66d33c304d418762fc71be2a',
          },
          records_3: {
            eventId: '66d33dcc4d418762fc71be50',
            crfId: '66d33c304d418762fc71be2a',
          },
          records_4: {
            eventId: '66d33dec4d418762fc71be57',
            crfId: '66d33c304d418762fc71be2a',
          },
          records_5: {
            eventId: '66d33f674d418762fc71be8b',
            crfId: '66d33c304d418762fc71be2a',
          }
        },
        cn: {
          projectId: '6656cb27cb66734951465acc',
          history: {
            eventId: '6659307091c0e64a529593d9',
            crfId: '6656cb67cb66734951465acf',
          },
          firstRecord: {
            eventId: '6659307091c0e64a529593d9',
            crfId: '66582082e236b933bb7adc9a',
          },
          records_1: {
            eventId: '665930eb91c0e64a529593dd',
            crfId: '6659243491c0e64a529593d6',
          },
          records_2: {
            eventId: '665930fb91c0e64a529593df',
            crfId: '6659243491c0e64a529593d6',
          },
          records_3: {
            eventId: '6659311491c0e64a529593e1',
            crfId: '6659243491c0e64a529593d6',
          },
          records_4: {
            eventId: '6659314391c0e64a529593e3',
            crfId: '6659243491c0e64a529593d6',
          },
          records_5: {
            eventId: '6659317e91c0e64a529593e9',
            crfId: '6659243491c0e64a529593d6',
          }
        },
      }
      projectObj = projectIdsMap['cn']
      if (window.lang === 'en') {
        projectObj = projectIdsMap['en']
      }
      projectId = projectObj.projectId
      try {
        result = await axios.get(`/api/records?projectId=${projectId}&subjectId=${subjectId}`, {
          projectId,
          subjectId
        })
      } catch (e) {
        // 在这里轮询
        const err = e.response
        console.log(err.data)
        this.$notify.error({ title: 'Error', message: `[${err.data.code}] ${err.data.msg}`, duration: 5000 })
      }
      const { records } = result.data.data
      console.log(records)
      if (result.data.code === 0) {
        this.dialogVisible = false
        records.map((record) => {
          record.data.date_of_visit = record.data.date_of_visit ? moment(record.data.date_of_visit).format('YYYY-MM-DD') : ''
          if (record.eventId == projectObj.history.eventId && record.crfId == projectObj.history.crfId ) {
            this.history = record
          }
          if (record.eventId == projectObj.firstRecord.eventId && record.crfId == projectObj.firstRecord.crfId ) {
            this.firstRecord = record
            console.log(record)
          }
          if (record.eventId == projectObj.records_1.eventId && record.crfId == projectObj.records_1.crfId ) {
            record.idx = 1
            this.records.push(record)
          }
          if (record.eventId == projectObj.records_2.eventId && record.crfId == projectObj.records_2.crfId ) {
            record.idx = 2
            this.records.push(record)
          }
          if (record.eventId == projectObj.records_3.eventId && record.crfId == projectObj.records_3.crfId ) {
            record.idx = 3
            this.records.push(record)
          }
          if (record.eventId == projectObj.records_4.eventId && record.crfId == projectObj.records_4.crfId ) {
            record.idx = 4
            this.records.push(record)
          }
          if (record.eventId == projectObj.records_5.eventId && record.crfId == projectObj.records_5.crfId ) {
            record.idx = 5
            this.records.push(record)
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
@media screen and (max-width: 500px) {
  .workspace {
    width: 100vw!important;
    .login-button {
      top: 10px!important;
    }
  }
}
.workspace {
  .login-button {
    top: -50px;
  }
  text-align: left;
  width: 1000px;
  margin: 20px auto;
  padding: 10px 20px;
  box-sizing: border-box;
  .data-item {
    .item-value {
      display: inline-block;
      margin-left: 10px;

      border-bottom: 1px solid #ccc;
      min-width: 50px;
    }
  }
  .info {
    padding-bottom: 5px;
    font-size: 13px;
    color: #303133;
    line-height: 1.769230769230769;
  }
  .data-table {
    margin: 10px 0 10px;
    border-collapse: collapse;
    th, td {
      padding: 5px 20px 5px;
    }
  }
}
</style>